//============================================================================
// Name        : quick_ship_out.ts
// Purpose     : Implement regular RFID Print page
// Created     : 2020-03-03
// Author      : Senitron Team
// Copyright   : Copyright 2020 Senitron Corporation. All rights reserved.
//============================================================================

import axios from "axios";
import {InitPage} from "../../index";

declare let App: any;
declare let storeLocation: string;
declare let storeLocationId: string;
declare let startReadingUrl: string;
declare let tagMetadataUrl: string;
declare let itemMetadataUrl: string;
declare let commitBolUrl: string;
declare let mockInsert: string;
declare let conversionData: object;
declare let binEnabled: boolean;
declare let managerExists: boolean;

// Status of Each ITEM
enum ItemStatus {
    MATCH,
    OVER_QTY,
    UNDER_QTY,
    WRONG
}

interface ITag {
    EPC: string;
    NumberOfPings: number;
    CurrentUnits: number;
    ItemNumber: string;
    AssetId: string;
    Description: string;
    Alu: string;
    Removed: boolean;
}

interface IEpcs {
    epcs: ITag[];
}

interface IItem {
    ItemNumber: string;
    Override: boolean;
    OverrideReason: string;
    Removed: boolean;
    NewItem: boolean;
    Valid: boolean;
}

class MfQuickShipOut {
    epcReadsChannel: any;
    tagsRead: ITag[]  = [];
    itemData: IItem[] = [];
    qualityHolds: any[] = [];

    init() {
        // Configure select fields
        $("select").select2({
            minimumResultsForSearch: 5
        });
        $("#pending_assignment_sub_zone_id").select2({
            minimumResultsForSearch: 5,
            width: "100%"
        });
        $('#transaction-form select').select2('destroy');

        // Store initial items
        this.addInitialItems();

        // Handle Read button
        $(".read-btn").on("click", this.startReading);

        $(".add-tag").on("click", this.addManualTag);
        $(".override-bol").on("click", this.overrideBol);
        $("#manualTagAddition-submit").on("click", this.submitManualTag);

        // Handle validations when filling BOL info
        $("#pending_assignment_sub_zone_id").on("change", this.validateItems);
        $("#bol_seal_num").on("change",                   this.validateItems);
        $("#bol_temp").on("change",                       this.validateItems);
        $("#bol_carrier").on("change",                    this.validateItems);
        $("#bol_trailer_num").on("change",                this.validateItems);

        // Save Settings
        this.restoredSavedSettings();
        $("#reader_id").on("change",       this.saveSelectedReader);
        $("#printer_id").on("change",      this.saveSelectedPrinter);
        $("#rememberReader").on("change",  this.saveSelectedReader);
        $("#rememberPrinter").on("change", this.saveSelectedPrinter);

        // When clicking "Override" fill confirm dialog and show it
        $("tr .override-check").on("change", e => this.setItemOverride(e.target));
        $("#cancel-override").on("click",   this.onCancelOverride);
        $("#continue-override").on("click", this.onContinueOverride);
        let _this = this;
        $(document).on("click", ".closeTag" , e => {
            _this.removeTag($(e.target).data("epc"));
        });

        // Handle Print button
        $(".submit-bol").on("click", this.onPrint);

        // Connect ActionCable to receive reads
        this.epcReadsChannel = App.cable.subscriptions.create(
            // Connection configuration
            {
                channel: "ReadsChannel",
                roomId: `${storeLocation}`
            },
            // Pass in connection callbacks
            {
                connected() { /* Called when the subscription is ready for use on the server */ },
                disconnected() { /* Called when the subscription has been terminated by the server */ },
                received: (data: any) => this.onEpcsRead(data)
            }
        );
    }

    addManualTag() {
        $("#manualTagAddition").modal("show");
    }

    overrideBol() {
        // Check BOL info is filled
        const shippingFrom  = $("#pending_assignment_sub_zone_id").val();
        const bolSealNum    = $("#bol_seal_num").val();
        const bolTemp       = $("#bol_temp").val();
        const bolCarrier    = $("#bol_carrier").val();
        const bolTrailerNum = $("#bol_trailer_num").val();

        if ((shippingFrom  == "") ||
            (bolSealNum    == "") ||
            (bolTemp       == "") ||
            (bolCarrier    == "") ||
            (bolTrailerNum == "")) {
            window.showErrorDialog("BOL required fields are not completely filled");
        } else {
            if( prompt("Password") == "Superman123" ) {
                $(".submit-bol").prop("disabled", "");
            }
        }
    }

    submitManualTag() {
        const data = { asset_id: $("#tag_number").val(), device_id: $("#reader_id").val() + "00", antenna_id:  $("#reader_id").val() + "01"}
        axios.post(mockInsert, data).then((resp) => {
            if (resp.status == 200) {
                console.log(resp);
                let display = "";
                if (resp.data.check_tag_id) {
                    display += "<b>You have typed: </b>" + resp.data.tag_ids + " tag(s). <br> <b>But we could insert only</b> " + resp.data.tags_send + " tag(s).";
                    display += "<br>Check if there are spaces or special characters (#, *, etc) in the text.<br>If so remove it and try again"
                } else {
                    display += "Tags Inserted to page.";
                }
                window.showInfoDialog(display);
                $("#manualTagAddition").modal("hide");
            }
            else {
                window.showErrorDialog("Unable to insert Tags, contact support!");
                $("#manualTagAddition").modal("hide");
            }
        });
    }

    startReading() {
        // Get the start url for the selected reader
        const startUrl = $("#reader_id option:selected").data("start-url");
        axios.get(startUrl);
        console.log("Starting selected reader.");

        // Disable read button
        $(".read-btn").prop("disabled", "disabled");

        // Re-enable the Read button after 5s
        setTimeout(() => $(".read-btn").prop("disabled", ""), 5000);
    }

    async onEpcsRead(data: IEpcs) {
        // Retrieve tag's meta information
        const tagsResp = await axios.post(`${tagMetadataUrl}?store_code=${storeLocationId}`, data.epcs.map((t: ITag) => t.EPC));
        tagsResp.data.map(t => {
            data.epcs.map(tag => {
                if (tag.EPC != t.epc_id) {
                    return;
                }
                tag.CurrentUnits = Number(t.current_units);
                tag.ItemNumber   = t.item_number;
                tag.AssetId      = t.asset_id;
            });
        });

        // Retrieve tag's item information
        const itemsResp = await axios.post(`${itemMetadataUrl}?store_code=${storeLocationId}`, data.epcs.map((t: ITag) => t.EPC));
        const tempQualityHolds = itemsResp.data.map(({item, quality_hold_id, asset_id}) => {
            data.epcs.map(tag => {
                if (tag.ItemNumber != item.number) {
                    return;
                }
                tag.Alu = item.alu;
                tag.Description = item.description;
            });

            return quality_hold_id ? { asset_id, item, quality_hold_id } : null;
        }).filter(qh => !!qh);

        if (tempQualityHolds.length) {
            const epcs = this.qualityHolds.map(i => i.asset_id);
            const newQaulityHolds = tempQualityHolds.filter(i => !epcs.includes(i.asset_id));
            if (newQaulityHolds.length) {
                this.qualityHolds = this.qualityHolds.concat(newQaulityHolds);
            }
        }

        // Save our read tag list
        this.appendNewTags(data.epcs);
        this.updateView();
    }

    addInitialItems() {
        const rows = $(".so-items tr");
        for (const row of Array.from(rows)) {
            const itemNumber = $(row).data("item-number");
            if (!itemNumber) {
                continue;
            }

            const it = this.findItem(itemNumber);
            if (!it) {
                this.itemData.push({
                    ItemNumber:     itemNumber,
                    OverrideReason: "",
                    Override:       false,
                    NewItem:        false,
                    Valid:          false,
                    Removed:        false
                } as IItem);
            }
        }
    }

    appendNewTags(tags: ITag[]) {
        const addList     = [];
        const currentList = this.tagsRead;

        if (this.tagsRead.length == 0) {
            this.tagsRead = tags;
            tags.map(nTag => {
                const it = this.findItem(nTag.ItemNumber);
                if (!it) {
                    this.itemData.push({
                        ItemNumber:     nTag.ItemNumber,
                        OverrideReason: "",
                        Override:       false,
                        NewItem:        false,
                        Valid:          false,
                        Removed:        false
                    } as IItem);
                }
            });
            return;
        }

        tags.map(nTag => {
            nTag.Removed = false;
            let found = false;
            currentList.map(t => {
                if (t.EPC == nTag.EPC) {
                    found = true;
                }
            });
            if (!found) {
                addList.push(nTag);
                // Add new items if there are new items
                const it = this.findItem(nTag.ItemNumber);
                if (!it) {
                    this.itemData.push({
                        ItemNumber:     nTag.ItemNumber,
                        OverrideReason: "",
                        Override:       false,
                        NewItem:        false,
                        Valid:          false,
                        Removed:        false
                    } as IItem);
                }
            }
        });

        // Append new tags
        this.tagsRead = currentList.concat(addList);
    }

    updateView(immediateCount = false) {
        let   totalUnits   = 0;
        let   totalWeight  = 0;
        const _this        = this;
        const existingItem = [];

        $(".bol-line-items").each(function() {
            const itemNumber = $(this).data("item-number");
            const itemTags   = _this.tagsRead.filter(t => t.ItemNumber == itemNumber && !t.Removed);
            let qty          = 0;
            const tagNumbers = [];

            const pings      = itemTags.length;

            itemTags.map(tag => {
                qty += tag.CurrentUnits;
                tagNumbers.push(`#${tag.AssetId} <img alt="Invalid" class="closeTag" src="/images/cancel.png" data-epc="${tag.EPC}">`);
            });

            console.log(itemTags);
            $(this).find(".it-tag-count").text(pings);
            if ($(this).data("souom") != undefined) {
                $(this).find(".it-weight").text(_this.convertQtyTo(itemNumber, qty, $(this).data("souom")));
            } else {
                $(this).find(".it-weight").text(Math.round(qty));
            }
            $(this).data("currentUnits", qty);

            // Check SO QTY and apply the correct label
            const soQty = Number($(this).data("sobunit"));
            $(this).find(".it-status").empty();
            if (soQty == qty) {
                $(this).find(".it-status").html(`<div class="label label-success">PERFECT MATCH</div>`);
                _this.itemData.map(it => {
                    if (it.ItemNumber != itemNumber) {
                        return;
                    }
                    it.Override = false;
                    it.Valid    = true;
                });
                _this.validateItems();
            } else if (soQty < qty) {
                $(this).find(".it-status").html(`<div class="label label-primary">QTY IS OVER</div>`);
            } else if (soQty > qty) {
                $(this).find(".it-status").html(`<div class="label label-warning">QTY IS UNDER</div>`);
            }

            if (pings > 0) {
                $(this).find(".tag-details").html(tagNumbers.join(", "));
            } else {
                console.log(pings);
                _this.itemData.map(it => {
                    if (it.ItemNumber != itemNumber) {
                        return;
                    }
                    if (it.NewItem) {
                        $(`#${it.ItemNumber}-row .remove-item`).click();
                    } else {
                        $(this).find(".tag-details").html("");
                    }
                });
            }
            existingItem.push(itemNumber);
        });

        this.tagsRead.map(tag => {
            if ( !existingItem.includes(tag.ItemNumber) && !tag.Removed ) {
                if ($(`.${tag.ItemNumber}-item-number`).length < 1) {
                    console.log("adding wrong item");
                    this.addWrongItem(tag);
                }
            }
        });

        Array.from($(".bol-line-items")).map(l => {
            totalUnits  += Number($(l).find(".it-tag-count").text());
            // totalWeight += Number($(l).find(".it-weight").text());
        });

        $(".total-rows-tags").text(totalUnits.toString());
        $(".tag-count").text(totalUnits);
    }

    addItemPings(tags: ITag[], item: string): number {
        return tags.reduce((acc, tag) => {
            if (tag.ItemNumber != item) {
                return acc;
            }
            return acc + tag.NumberOfPings;
            // tslint:disable-next-line: align
        }, 0);
    }

    addWrongItem(tag: ITag) {
        console.log("WRONG ITEM");
        if (tag.Alu == undefined) {
            return 0;
        }

        console.log(tag.Alu, tag.Description);
        const itemTags = this.tagsRead.filter(t => t.ItemNumber == tag.ItemNumber && !tag.Removed);

        const pings      = itemTags.length;

        let qty          = 0;
        const tagNumbers = [];
        itemTags.map(t => {
            qty += t.CurrentUnits;
            tagNumbers.push(`#${t.AssetId} <img alt="Invalid" class="closeTag" src="/images/cancel.png" data-epc="${t.EPC}">`);
        });

        const newRow = `
        <tr id="${tag.ItemNumber}-row"
            data-item-number="${tag.ItemNumber}"
            data-currentUnits=${qty}
            class="${tag.ItemNumber}-item-number bol-line-items saleLineNumber">
            <td style="text-align: left">
                ${tag.Alu} ${tag.Description}<br>
                <small class="tag-details">${tagNumbers.join(", ")}</small>
            </td>
            <td><button class="btn btn-danger btn-sm remove-item" type="button">Remove</button></td>
            <td></td>
            <td class='bold-col it-tag-count'>${pings}</td>
            <td class='bold-col it-weight'>${Math.round(qty)}</td>
            <td><div class="label label-danger">WRONG ITEM</div></td>
            <td class="it-valid"><img alt="Invalid" class="val-img" src="/images/cancel.png" /></td>
            <td>
                <div class="checkbox justify-content-center">
                    <label>
                        <input type="checkbox" class="override-check" name="">
                        <span class="cr">
                        <i class="cr-icon fa fa-check"></i>
                        </span>
                        <span></span>
                    </label>
                </div>
            </td>
        </tr>`;

        const finalRow = $(".so-items tbody tr").last()[0].outerHTML;
        $(".so-items tbody tr").last().remove();
        $(".so-items tbody").append($(newRow));
        $(".so-items tbody").append($(finalRow));

        // Add wrong item to items list
        this.itemData.push({
            ItemNumber:     tag.ItemNumber,
            Override:       false,
            OverrideReason: "",
            NewItem:        true,
            Valid:          false,
            Removed:        false
        } as IItem);

        // Add new events for override checkboxes
        $(`#${tag.ItemNumber}-row .override-check`).on("change", e => this.setItemOverride(e.target));

        // Handle removing wrong items
        $(`#${tag.ItemNumber}-row .remove-item`).on("click", e => this.removeWrongItem(e.target));
    }

    convertQtyTo = (item: string, qty: number, to: string) => {
        if (conversionData[item] == undefined ) {
            return qty;
        }
        if (conversionData[item][to] == undefined ) {
            return qty;
        }

        return (qty / conversionData[item][to]).toFixed(0);
    }

    removeWrongItem = (el: HTMLElement) => {
        const targetBtn  = $(el);
        const row        = targetBtn.parent().parent();
        const itemNumber = row.data("item-number");

        // Mark item as removed
        this.itemData = this.itemData.filter(it => {
            if (it.ItemNumber != itemNumber) {
                return it;
            }
            it.Removed = true;
            return it;
        });

        this.tagsRead.map(t => {
            if (t.ItemNumber != itemNumber) {
                return;
            }
            t.Removed = true;
            return t;
        });

        row.remove();
        this.updateView(true);
    }

    removeTag = (EPC: string) => {
        console.log(EPC);
        this.tagsRead.map(t => {
            if (t.EPC != EPC) {
                return;
            }
            t.Removed = true;
            return t;
        });

        this.updateView(true);
    }

    validateItems = () => {
        let allValid = true;
        let submitBol = true;
        // Update all rows valid status
        this.itemData.map(it => {
            if (it.Valid || it.Override || it.Removed) {
                it.Valid = true;
            }
            else {
                allValid = false;
            }

            const rowEl = $(`#${it.ItemNumber}-row`);
            if (it.Valid || it.Override || it.Removed) {
                $(rowEl).find(".it-valid").html(`<img class="val-img" alt="Valid" src="/images/greencheck.png" />`);
            }
            else {
                $(rowEl).find(".it-valid").html(`<img alt="Invalid" class="val-img" src="/images/cancel.png" />`);
            }
            const rowImg = $(rowEl).find(".it-valid").find("img")[0];
            if(rowImg != undefined){
                if(rowImg.alt == "Invalid") {
                    submitBol = false;
                }
            }
        });

        // Check BOL info is filled
        const shippingFrom  = $("#pending_assignment_sub_zone_id").val();
        const bolSealNum    = $("#bol_seal_num").val();
        const bolTemp       = $("#bol_temp").val();
        const bolCarrier    = $("#bol_carrier").val();
        const bolTrailerNum = $("#bol_trailer_num").val();
        const printerId     = $("#printer_id").val();

        if ((shippingFrom  == "") ||
            (bolSealNum    == "") ||
            (bolTemp       == "") ||
            (bolCarrier    == "") ||
            (bolTrailerNum == "")) {
            allValid = false;
            submitBol = false;
        }

        return submitBol;
    }

    saveSelectedReader() {
        if ($("#rememberReader").is(":checked")) {
            localStorage.setItem("selectedReaderId", $("#reader_id").val().toString());
        }
        else {
            localStorage.removeItem("selectedReaderId");
        }
    }

    saveSelectedPrinter() {
        if ($("#rememberPrinter").is(":checked")) {
            localStorage.setItem("selectedPrinterId", $("#printer_id").val().toString());
        }
        else {
            localStorage.removeItem("selectedPrinterId");
        }
    }

    restoredSavedSettings() {
        const selectedReaderId  = localStorage.getItem("selectedReaderId");
        const selectedPrinterId = localStorage.getItem("selectedPrinterId");

        if (selectedReaderId) {
            $("#reader_id").val(selectedReaderId);
            $("#reader_id").trigger("change");
            $("#rememberReader").prop("checked", "checked");
        }
        if (selectedPrinterId) {
            $("#printer_id").val(selectedPrinterId);
            $("#printer_id").trigger("change");
            $("#rememberPrinter").prop("checked", "checked");
        }
    }

    setReadCount(count: number) {
        $(".total-rows-tags").text(count.toString());
        $(".tag-count").text(count);
        this.animateCount(".tag-count", count);
    }

    setWeightCount(weightCount: number) {
        $(".total-rows-weight").text(weightCount.toString() + " LBS");
        $(".weight-text").text(weightCount);
        this.animateCount(".weight-text", weightCount);
    }

    animateCount(elSelector: string, _count: number) {
        const counterEl = $(elSelector);
        counterEl.prop("Counter", 0).animate(
            {
                Counter: counterEl.text()
            },
            {
                duration: 4000,
                easing:   "swing",
                step:     now => {
                    counterEl.text(Math.ceil(now));
                }
            }
        );
    }

    setItemOverride(el) {
        // Find parent
        const parent = $(el).parent().parent().parent().parent();

        // Get item number
        const item = this.findItem($(parent).data("item-number"));
        if (!item) {
            return;
        }

        if ($(el).is(":checked")) {
            this.setOverrideMessage(item.ItemNumber);
            $("#shipout-override-confirm").data("item-number", item.ItemNumber);
            $("#override_reason").val(item.OverrideReason);
            $("#shipout-override-confirm").modal("show");
        }
        else {
            this.itemData.map(it => {
                if (it.ItemNumber != item.ItemNumber) {
                    return;
                }
                it.Override = false;
                it.Valid    = false;
            });
            this.validateItems();
        }
    }

    setOverrideMessage = (itemNumber: string) => {
        let totalQty = 0;
        const itemTags   = this.tagsRead.filter(t => t.ItemNumber == itemNumber && !t.Removed);
        itemTags.map(tag => {
            totalQty += Math.round(tag.CurrentUnits);
        });
        const sobunit = $(`#${itemNumber}-row`).data("sobunit");
        if (sobunit == undefined) {
            $("#shipout-override-message").text("are for Item which is not part of the SO");
        } else if (sobunit > totalQty) {
            $("#shipout-override-message").text("are less than the SO ordered quantities");
        } else if (sobunit < totalQty) {
            $("#shipout-override-message").text("are more than the SO ordered quantities");
        } else {
            console.log(sobunit);
            console.log(totalQty);
            $("#shipout-override-message").text("");
        }
    }

    onCancelOverride = () => {
        const itemNumber = $("#shipout-override-confirm").data("item-number");
        $(`#${itemNumber}-row`).find(".override-check").prop("checked", "");
        $("#shipout-override-confirm").modal("hide");
    }

    onContinueOverride = () => {
        const itemNumber = $("#shipout-override-confirm").data("item-number");
        this.itemData.map(it => {
            if (it.ItemNumber != itemNumber) {
                return;
            }
            it.Override = true;
            it.Valid    = true;
            it.OverrideReason = $("#override_reason").val().toString();
        });
        $("#shipout-override-confirm").modal("hide");
        this.validateItems();
    }

    findItem(itemNumber: string): IItem {
        const items = this.itemData.filter(it => it.ItemNumber == itemNumber);
        if (items.length > 0) {
            return items[0];
        }
        return null;
    }

    onPrint = async () => {
        // @ts-ignore
        if (this.qualityHolds.length && !window.managerExists) {
            const assetIds = this.tagsRead.filter(t => t.Removed).map(i => i.AssetId);
            const items = this.qualityHolds.filter(i => !assetIds.includes(i.asset_id));

            if (items.length) {
                $('#quality-hold-tbody').html(items.map(i => `<tr><td>${i.asset_id}</td><td>${i.item.alu}</td><td>${i.item.description}</td><td>${i.quality_hold_id}</td></tr>`).join('\n'));
                $('#quality-hold-dialog').modal('show');
                return;
            }
        }
        if ($("#printer_id").val() == undefined || $("#printer_id").val() == "") {
            alert("Please select printer to continue");
            return;
        }
        const shippingFrom  = $("#pending_assignment_sub_zone_id").val();
        const bolSealNum    = $("#bol_seal_num").val();
        const bolTemp       = $("#bol_temp").val();
        const bolCarrier    = $("#bol_carrier").val();
        const bolTrailerNum = $("#bol_trailer_num").val();

        if ((shippingFrom  == "") ||
            (bolSealNum    == "") ||
            (bolTemp       == "") ||
            (bolCarrier    == "") ||
            (bolTrailerNum == "")) {
            window.showErrorDialog("BOL required fields are not completely filled");
            return;
        }

        const bolItems = this.itemData.filter(it => !it.Removed).map(it => {
            return {
                itemNumber:     it.ItemNumber,
                epcs:           this.tagsRead.filter(t => t.ItemNumber == it.ItemNumber && !t.Removed),
                tagCount:       $(`#${it.ItemNumber}-row`).find(".it-tag-count").text(),
                currentUnits:   $(`#${it.ItemNumber}-row`).find(".it-weight").text(),
                override:       it.Override,
                overrideReason: it.OverrideReason,
                removed:        it.Removed,
                newItem:        it.NewItem
            };
        });

        // Put together BOL data for saving
        const bolData = {
            selectedPrinterId: $("#printer_id").val(),

            shippingFrom:      $("#pending_assignment_sub_zone_id").val(),
            bolSealNum:        $("#bol_seal_num").val(),
            bolTemp:           $("#bol_temp").val(),
            bolCarrier:        $("#bol_carrier").val(),
            bolTrailerNum:     $("#bol_trailer_num").val(),
            locationId:        $("#pending_assignment_sub_zone_id").val(),

            soProcessId:       $("#soProcessId").val(),
            removedEpcs:       this.tagsRead.filter(t => t.Removed).map(t => t.EPC),
            bolItems
        };

        if (this.validateItems()) {
            const resp = await axios.post(commitBolUrl, bolData).catch(error => { console.log(error.response.data); return error.response });
            console.log(resp.status);
            if (resp.status != 200) {
                if(resp.data.error == "unclosed WO") {
                    window.showErrorDialog(resp.data.message);
                } else if (resp.data.error == "Wrong SO Step") {
                    window.showErrorDialog(resp.data.message);
                } else {
                    window.showErrorDialog("Error saving BOL");
                }
            } else if (binEnabled) {
                const fields = ['manufacturing_bin_direction',
                    'manufacturing_bin_reason',
                    'manufacturing_bin_transferred_at_1i',
                    'manufacturing_bin_transferred_at_2i',
                    'manufacturing_bin_transferred_at_3i',
                    'manufacturing_bin_transferred_at_4i',
                    'manufacturing_bin_transferred_at_5i',
                    'manufacturing_bin_customer_id',
                    'manufacturing_bin_document_number',
                    'manufacturing_bin_damaged_count'];
                $("#redirect_url").val(resp.data.details_url);
                fields.forEach(field => $(`#${field}`).prop('disabled', 'disabled'))
                $("#manufacturing_bin_total_count").val($(".tag-count").text());
                $("#transaction-form").modal('show');

                $('#bin-submit').on("click", () => fields.forEach(field => $(`#${field}`).prop('disabled', false)));
                $('#close-modal').on("click", () => {
                    window.location.replace(resp.data.details_url)
                });
            } else {
                window.showInfoDialog("BOL Saved");
                window.location.replace(resp.data.details_url);
            }
        } else {
            window.showErrorDialog("Kindly confirm all line has a valid green checkbox.")
        }
    }
}

export function LoadPage() {
    InitPage("quick_ship_out", () => {
        const quickShipOut = new MfQuickShipOut();
        quickShipOut.init();
    });
}
